<div class="panel_wrapper">
  <mat-expansion-panel (opened)="handleOpened()" (closed)="handleClosed()" hideToggle="true" [expanded]="panelOpenState" class="px-md-4">
    <mat-expansion-panel-header tabindex="0" [attr.aria-label]="goal.title + (panelOpenState ? ', expanded' : ', collapsed')" [style.background-color]="color" [collapsedHeight]="'auto'" [expandedHeight]="'auto'" class="main-header taxanomy-header p-0 mb-2">
      <mat-panel-title class="align-items-center justify-content-between">
        <div class="d-flex align-items-center">
          <div [style.background-color]="color" class="taxanomy-number text-center row align-items-center">
            <span>{{goal.title}}</span>
          </div>
          <span class="panel-header-text_ d-inline-block goal_description_span">
            <app-dynamic-content
              [contentId]="'new-action-taxnomy-goals-desc'"
              [htmlContent]="goal.description">
            </app-dynamic-content>
          </span>
        </div>
        <div class="arrows" tabindex="0" role="button" [attr.aria-label]="(panelOpenState ? 'Collapse' : 'Expand') + ' ' + goal.title" (keydown)="onArrowKeydown($event)">
          <svg [style.fill]="color" class="taxanomy-arrow-up" *ngIf="panelOpenState" xmlns="http://www.w3.org/2000/svg" width="49.61" height="49.61" viewBox="0 0 49.61 49.61">
            <path class="a"
              d="M24.805,49.61A24.805,24.805,0,0,1,7.265,7.265a24.805,24.805,0,0,1,35.08,35.08A24.643,24.643,0,0,1,24.805,49.61Zm0-45.735A20.929,20.929,0,1,0,45.735,24.805,20.953,20.953,0,0,0,24.805,3.876ZM38.2,21.511,35.464,18.77,24.805,29.429,14.147,18.77l-2.741,2.741,13.4,13.4Zm0,0"
              transform="translate(49.61 49.61) rotate(180)" />
          </svg>

          <svg [style.fill]="color" class="taxanomy-arrow-down" *ngIf="!panelOpenState" xmlns="http://www.w3.org/2000/svg" width="49.61" height="49.61" viewBox="0 0 49.61 49.61">
            <path class="a"
              d="M24.805,49.61A24.805,24.805,0,0,1,7.265,7.265a24.805,24.805,0,0,1,35.08,35.08A24.643,24.643,0,0,1,24.805,49.61Zm0-45.735A20.929,20.929,0,1,0,45.735,24.805,20.953,20.953,0,0,0,24.805,3.876ZM38.2,21.511,35.464,18.77,24.805,29.429,14.147,18.77l-2.741,2.741,13.4,13.4Zm0,0"
              transform="translate(0)" />
          </svg>
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <ng-container *ngIf="this.includeTier == 'Strategies'">
      <kla-new-action-taxonomy-strategy *ngFor="let strategy of goal.strategies" [strategy]="strategy" [color]="color" [includeTier]="includeTier" [config]="config" [parentGoalTitle]="goal.title" [parentCategoryTitle]="parentCategoryTitle"></kla-new-action-taxonomy-strategy>
    </ng-container>
    <ng-container *ngIf="this.includeTier == 'Actions'">
      <kla-new-action-taxonomy-action [actions]="goal.actions" [color]="color" [goalChild]="true" [includeTier]="includeTier" [config]="config"></kla-new-action-taxonomy-action>
   </ng-container>
  </mat-expansion-panel>
</div>
